<template>
  <v-container fluid>
    <v-data-table v-model="selected" :loading="loading ? '#0482fb' : null" :headers="headers" :items="statQuoting"
      item-key="name">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des cotations</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <!-- <v-switch
            v-model="showAllFil"
            label="Afficher toutes les données"
            color="#0482fb"
            @change="showAllFillData"
            class="pt-5"
          ></v-switch>
          <v-switch
            v-model="showYearFil"
            label="afficher les données de l'année "
            color="#0482fb"
            @change="showAllFillData"
            class="ml-10 pt-5"
          ></v-switch> -->
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche et importation vers excel ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field outlined color="#0482fb" label="Date demande SC  début" class="pt-5 pa-2"
                      v-model="salesDepartmentQuotingRequestDateStart" prepend-inner-icon="mdi-magnify" dense
                      type="date" flat background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field outlined color="#0482fb" label="Date demande SC fin" class="pt-5 pa-2"
                      v-model="salesDepartmentQuotingRequestDateEnd" prepend-inner-icon="mdi-magnify" dense type="date"
                      flat background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="fileName" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="company" flat background-color="grey lighten-4" label="Compagnie ..."></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-text-field outlined color="#0482fb" label="Date demande DT début" class="pt-5 pa-2"
                      v-model="technicalDirectionQuotingRequestDateStart" prepend-inner-icon="mdi-magnify" dense
                      type="date" flat background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field outlined color="#0482fb" label="Date demande DT fin" class="pt-5 pa-2"
                      v-model="technicalDirectionQuotingRequestDateEnd" prepend-inner-icon="mdi-magnify" dense
                      type="date" flat background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-select outlined :items="items" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                      v-model="status" dense flat background-color="grey lighten-4" label="Statut"></v-select>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>

                  <v-btn class="white--text pa-5" color="#1D6F42" :href="statFileCotation" target="_blank">
                    <v-icon size="30" class="mr-8" color="#fff" left>
                      mdi-microsoft-excel
                    </v-icon>
                    Exporter vers un tableau EXCEL
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { importDataExcel } from "../../exportDoc/index.js";
export default {
  name: "chartCall",
  data() {
    return {
      singleSelect: false,
      loading: false,
      selected: [],
      companyNameList: [],
      productNameList: [],
      items: ["*", "Envoie compagnie exécutée", "Demande cotation SC", "Retour compagnie", "Envoie client", "Retour client"],
      headers: [
        {
          text: "Nom / Raison sociale",
          align: "start",
          width: "200px",
          sortable: false,
          value: "name",
        },
        { text: "Produit", width: "200px", value: "product" },

        { text: "Compagnies", width: "200px", value: "company" },
        {
          text: "Date réception demande",
          width: "200px",
          value: "createdAtFr",
        },
        {
          text: "Date exécution demande",
          width: "200px",
          value: "returnDateFr",
        },
        { text: "Prime Nette", width: "200px", value: "netPrime" },
        { text: "Accessoire", width: "200px", value: "accessory" },
        { text: "Taxe", width: "200px", value: "tax" },
        { text: "Prime TTC", width: "200px", value: "TTCPrime" },
        {
          text: "Date retour compagnie",
          width: "200px",
          value: "companyReturn.createdAtFr",
        },
        {
          text: "Date retour client",
          width: "200px",
          value: "customerReturn.createdAtFr",
        },
        { text: "Nom Agent", width: "200px", value: "agentName" },
        { text: "Statut", width: "200px", value: "status" },
      ],
      workSheetColumnName: [
        "Nom / Raison sociale",
        "Produit",
        "Compagnies",
        "Date réception demande",
        "Date exécution demande",
        "Prime Nette",
        "Accessoire",
        "Taxe",
        "Prime TTC",
        "Date retour compagnie",
        "Date retour client",
        "Nom de l'agent",
        "Statut",
      ],
      workSheetName: "Rapport Statistique cotations",
      nombre: "cotation",
      users: [],
    };
  },
  mounted() {
    this.initStatQuoting();
  },
  computed: {
    ...mapGetters(["statQuoting", "Companies", "Products", "statFileCotation"]),
  },
  watch: {
    statQuoting() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
      this.seedCoinsuranceCompanyNameList();
    },
  },
  methods: {
    importData() {
      //console.log(this.statCall);
      this.users = this.statQuoting;

      importDataExcel(
        this.workSheetColumnName,
        this.workSheetName,
        this.nombre,
        this.users
      );
    },
    onEnter: function () {
      this.initStatQuoting();
    },
    ...mapActions(["getStateQuoting", "getCompanies", "getProducts"]),
    showAllFillData() {
      this.initStatQuoting();
      //alert(this.showAllFil);
    },

    async initStatQuoting() {
      this.loading = true;
      try {
        await this.getStateQuoting({
          fileName: this.fileName,
          periodStartDate: this.periodStartDate,
          periodEndDate: this.periodEndDate,
          salesDepartmentQuotingRequestDateStart: this.salesDepartmentQuotingRequestDateStart,
          salesDepartmentQuotingRequestDateEnd: this.salesDepartmentQuotingRequestDateEnd,
          technicalDirectionQuotingRequestDateStart: this.technicalDirectionQuotingRequestDateStart,
          technicalDirectionQuotingRequestDateEnd: this.technicalDirectionQuotingRequestDateEnd,
          currentYear: this.showYearFil,
          withoutPeriod: this.showAllFil,
          product: this.product,
          company: this.company,
          returnStartDate: this.returnStartDate,
          returnEndDate: this.returnEndDate,
          status: this.status
        });
        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
  },
};
</script>
